// Mock data for White Shiba Inu clone

export const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About', href: '#about' },
  { name: 'Features', href: '#features' },
  { name: 'Token', href: '#tokenomics' },
  { name: 'Roadmap', href: '#roadmap' },
];

export const heroStats = [
  { value: '1B', label: 'Total Supply' },
  { value: '0%', label: 'Buy Tax' },
  { value: '100%', label: 'Community' },
];

export const features = [
  {
    title: 'Community Driven',
    description: 'Built by the community, for the community. Every holder has a voice.',
    icon: 'Users',
  },
  {
    title: 'Fully Transparent',
    description: 'Contract audited. Liquidity burned. No hidden wallets or shady moves.',
    icon: 'Shield',
  },
  {
    title: 'Fair Launch',
    description: 'No presale. No team allocation. Everyone starts on equal footing.',
    icon: 'Scale',
  },
  {
    title: 'Growth Focused',
    description: 'Strategic marketing and partnerships to drive sustained growth.',
    icon: 'TrendingUp',
  },
];

export const tokenomics = {
  tokenName: 'White Shiba Inu',
  ticker: '$WhiteShiba',
  totalSupply: '1,000,000,000',
  blockchain: 'Solana',
  contractAddress: '5yMU4CEnjfT37mEaFFnPTWwy1YC23GvVjJxuLzPTpump',
};

export const roadmap = [
  {
    phase: 'Phase 1',
    title: 'Launch Phase',
    items: [
      'Fair launch on Pumpfun',
      'Website launch',
      'Social media activation',
      'Community building',
    ],
    number: 1,
  },
  {
    phase: 'Phase 2',
    title: 'Growth Phase',
    items: [
      'CoinGecko and CoinMarketCap listings',
      'Influencer partnerships',
      '10,000+ holders',
    ],
    number: 2,
  },
  {
    phase: 'Phase 3',
    title: 'Expansion Phase',
    items: [
      'CEX listings',
      'NFT collection launch',
      'Merchandise store',
      'Strategic partnerships',
    ],
    number: 3,
  },
  {
    phase: 'Phase 4',
    title: 'Future Vision',
    items: [
      'To be decided by the community',
      'Your voice matters',
    ],
    number: 4,
  },
];

export const communityStats = [
  { value: '10K+', label: 'Holders' },
  { value: '50K+', label: 'Community' },
  { value: '24/7', label: 'Support' },
  { value: '100%', label: 'Transparent' },
];

export const socialLinks = {
  telegram: 'https://t.me/WhiteShibainuOfficial',
  twitter: 'https://x.com/WhiteShibainu',
};

export const logoUrl = 'https://customer-assets.emergentagent.com/job_ee1a010c-e064-4966-a3f6-4964865ad26b/artifacts/omavr94f_WS.svg';
